import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from './api.service';
import {
    CameraTypes,
    ExternalCameraSetting,
    ApiMode
} from '@pages/camera-settings/models';

@Injectable({
    providedIn: 'root'
})
export class CameraSettingService extends ApiService {
    constructor(private http: HttpClient) {
        super();
    }

    getCameraSettings(Id: number, mode: ApiMode, cameraType: CameraTypes) {
        let apiCameraNumber: number = 0;
        let cameraName: string = '';

        switch (cameraType) {
            case CameraTypes.Matrix2Plus:
                apiCameraNumber = 7;
                cameraName = 'Matrix2Plus';
                break;
            case CameraTypes.Matrix4G:
                apiCameraNumber = 8;
                cameraName = 'Matrix4G';
                break;
            case CameraTypes.MatrixMini:
                apiCameraNumber = 9;
                cameraName = 'MatrixMini';
                break;
        }

        let url =
            this.baseUrl +
            `/api/Kiosk/GetCameraSettingsByUserId?id=${Id}&Modeid=${mode}&provider=${cameraType}`;
        return this.http.get(url);
    }

    updateCameraSettings(cameraSetting: ExternalCameraSetting) {
        return this.http.post(
            this.baseUrl + '/api/Kiosk/UpdateCameraSettings',
            cameraSetting
        );
    }
}
